import { motion } from "framer-motion";
import { MoveRight } from "lucide-react";
import { useLanguage } from "@/i18n";
import { scrollToSection } from "@/scroll";
import { reveal } from "@/components/Section";

const BANNER_IMG =
  "https://images.unsplash.com/photo-1781819062932-b9cee9699bba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxkZXNlcnQlMjBkdW5lJTIwc3Vuc2V0JTIwb3ZlcmxhbmR8ZW58MHx8fHwxNzg4ODk4Mzg4fDA&ixlib=rb-4.1.0&q=85";

export default function Banner() {
  const { t } = useLanguage();
  return (
    <section className="relative border-y border-line overflow-hidden" data-testid="lifestyle-banner">
      <div className="grid lg:grid-cols-2">
        <div className="flex flex-col justify-center px-5 sm:px-8 lg:pl-[max(1.25rem,calc((100vw-1500px)/2+2rem))] py-24 sm:py-32">
          <motion.p {...reveal} className="font-telemetry text-xs uppercase tracking-[0.3em] text-blaze mb-5">
            {t.banner.eyebrow}
          </motion.p>
          <motion.h2
            {...reveal}
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-[0.92] text-bone"
          >
            {t.banner.titleA}
            <br />
            <span className="text-blaze">{t.banner.titleB}</span>
          </motion.h2>
          <motion.p {...reveal} className="mt-6 max-w-md text-sm sm:text-base leading-relaxed text-ash">
            {t.banner.text}
          </motion.p>
          <motion.div {...reveal} className="mt-9">
            <button
              data-testid="banner-cta-join-btn"
              onClick={() => scrollToSection("#community")}
              className="group font-telemetry text-xs uppercase tracking-[0.22em] border border-sand/40 text-sand px-8 py-4 flex items-center gap-3 hover:border-blaze hover:text-blaze transition-colors duration-300 w-max"
            >
              {t.banner.cta}
              <MoveRight size={15} className="group-hover:translate-x-1.5 transition-transform duration-300" />
            </button>
          </motion.div>
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
          className="relative min-h-[340px] lg:min-h-[560px]"
        >
          <img
            src={BANNER_IMG}
            alt="Dust Republic overland lifestyle"
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover warm-grade"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/20 to-transparent lg:bg-gradient-to-r" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent lg:hidden" />
          <span className="absolute bottom-4 right-4 font-telemetry text-[10px] tracking-[0.2em] uppercase text-sand/70">
            43.06°N — 11.61°E
          </span>
        </motion.div>
      </div>
    </section>
  );
}
